var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.blocks),function(b,i){return _c('block_' + b.acf_fc_layout,{key:i,tag:"component",attrs:{"payload":b}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }